import { GetConstraintsResponse } from 'api/typegen/application/constraints/get';
import fetchWebApi from 'api/fetchWebApi';

const getClientConstraintsApiCall = async (): Promise<GetConstraintsResponse> =>
  fetchWebApi('/client/application/constraints');

export default getClientConstraintsApiCall;
